The input parameter for the `setDisabledFeatures` mutation.
